import React from 'react';
import { Container, Typography, Paper } from '@mui/material';
import './LegalPages.css';

const MesafeliSatisSozlesmesi = () => {
  return (
    <Container maxWidth="md" className="legal-container">
      <Paper elevation={3} className="legal-paper">
        <Typography variant="h4" component="h1" gutterBottom>
          Mesafeli Satış Sözleşmesi
        </Typography>

        <div className="section">
          <Typography variant="h6" className="section-title">
            1. Taraflar
          </Typography>
          <Typography variant="body1" paragraph>
            İşbu sözleşme, HOPS (bundan sonra SATICI olarak anılacaktır) ile alıcı (bundan sonra ALICI olarak anılacaktır) 
            arasında aşağıdaki şartlar çerçevesinde düzenlenmiştir.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            2. Sözleşmenin Konusu
          </Typography>
          <Typography variant="body1" paragraph>
            İşbu sözleşmenin konusu, ALICI'nın SATICI'ya ait platform üzerinden satın aldığı kontör hizmetinin 
            satışı ve teslimi ile ilgili olarak 6502 Sayılı Tüketicinin Korunması Hakkında Kanun hükümleri 
            gereğince tarafların hak ve yükümlülüklerinin belirlenmesidir.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            3. Hizmet Bilgileri
          </Typography>
          <Typography variant="body1" paragraph>
            Satın alınan kontör paketi, dijital bir hizmet olup, ödemenin tamamlanmasını takiben 
            ALICI'nın hesabına otomatik olarak tanımlanacaktır. Kontörler, aktivasyon tarihinden itibaren 
            süresiz olarak geçerlidir.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            4. Ödeme ve Teslimat
          </Typography>
          <Typography variant="body1" paragraph>
            Ödeme, platform üzerinden kredi kartı veya banka kartı ile gerçekleştirilir. 
            Kontörler, ödemenin başarıyla tamamlanmasının ardından anında hesaba tanımlanır. 
            Dijital hizmet olması sebebiyle fiziksel teslimat söz konusu değildir.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            5. Cayma Hakkı
          </Typography>
          <Typography variant="body1" paragraph>
            Dijital içerik/hizmet sunumu niteliğinde olan kontör satışlarında, hizmetin tesliminin/ifasının başladığı 
            an itibarıyla cayma hakkı kullanılamaz. Bu husus 6502 Sayılı Kanun'un 15/1-ğ maddesi uyarınca 
            cayma hakkı istisnası kapsamındadır.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            6. Uyuşmazlık Çözümü
          </Typography>
          <Typography variant="body1" paragraph>
            İşbu sözleşmeden doğan uyuşmazlıklarda, Gümrük ve Ticaret Bakanlığı tarafından her yıl Aralık ayında 
            ilan edilen değere kadar olan uyuşmazlıklarda Tüketici Hakem Heyetleri, bu değerin üzerindeki 
            uyuşmazlıklarda Tüketici Mahkemeleri yetkilidir.
          </Typography>
        </div>

        <div className="contact-info">
          <Typography variant="h6" gutterBottom>
            Satıcı Bilgileri
          </Typography>
          <Typography variant="body1">
            Unvan: TUĞBA HAZAL ÖZKARAASLAN HOPS YAZILIM SİSTEMLERİ TEKNOPARK ŞUBESİ
          </Typography>
          <Typography variant="body1">
            Adres: Yeniköy Merkez Mah. Vatan Cad. Teknopark Sitesi Başiskele / Kocaeli
          </Typography>
          <Typography variant="body1">
            E-posta: info@hopssoftware.com
          </Typography>
          <Typography variant="body1">
            Telefon: +90 552 464 11 16
          </Typography>
          <Typography variant="body1">
            MERSİS No: 3888146357 / 154133525540002
          </Typography>
        </div>
      </Paper>
    </Container>
  );
};

export default MesafeliSatisSozlesmesi; 